module.exports = __webpack_public_path__ + "img/maps.98d8aab7.svg";